export default state => ({
  ...state,
  initialisationFailure: true
});
